import React from "react";
import type { MoveTarget } from "../../state";

interface Props {
  target: MoveTarget;
  onDropMove: (target: MoveTarget) => void;
  className?: string;
  onClick?: () => void;
  /** Optional: also act as a drag SOURCE (e.g. a zone head you reorder). */
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
  children: React.ReactNode;
}

/** A row that accepts a dragged activity. Highlight state is LOCAL, so hovering
 *  a target only re-renders that target — never the row being dragged (which is
 *  what tends to break native drag-and-drop in React). */
const DropTarget: React.FC<Props> = ({
  target,
  onDropMove,
  className,
  onClick,
  draggable,
  onDragStart,
  onDragEnd,
  children,
}) => {
  const [over, setOver] = React.useState(false);
  return (
    <div
      className={`${className ?? ""} ${over ? "is-drop-over" : ""}`}
      onClick={onClick}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragOver={(e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        if (!over) setOver(true);
      }}
      onDragLeave={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget as Node)) setOver(false);
      }}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        onDropMove(target);
      }}
    >
      {children}
    </div>
  );
};

export default DropTarget;
